import { render, staticRenderFns } from "./service_index.vue?vue&type=template&id=38cb57bc&scoped=true&"
import script from "./service_index.vue?vue&type=script&lang=js&"
export * from "./service_index.vue?vue&type=script&lang=js&"
import style0 from "./service_index.vue?vue&type=style&index=0&id=38cb57bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb57bc",
  null
  
)

export default component.exports